import type { DemoKey } from './keys';

export const ta: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'வடிவியல் · 3D',
  'panel.figure': 'வடிவம்',
  'panel.dims': 'அளவுகள்',
  'panel.style': 'தோற்றம்',
  'panel.lines': 'சிறப்புக் கோடுகள்',
  'style.body': 'உடல்',
  'style.line': 'கோடு',
  'style.cut': 'வெட்டு',
  'style.labels': 'முனை லேபிள்கள்',
  'group.face': 'முக மூலைவிட்டங்கள் / உருவாக்கிகள்',
  'group.space': 'மூலைவிட்டங்கள் / அச்சுகள் / நடுக்கோடுகள்',
  'split.label': 'வெட்டு',
  'btn.animate': 'அசை',
  'btn.reset': 'மீட்டமை',
  'hint.line1': 'சுழற்ற இழுக்கவும் · ஜூம் செய்ய ஸ்க்ரோல்',
  'hint.line2': 'தேர்ந்தெடுக்க கோட்டை கிளிக் செய்க',
  'fig.cuboid': 'கனச்சதுரம்',
  'fig.cube': 'கனசதுரம்',
  'fig.triPrism': 'முக்கோண முப்பட்டகம்',
  'fig.hexPrism': 'அறுகோண முப்பட்டகம்',
  'fig.tetrahedron': 'நாற்முகி',
  'fig.squarePyramid': 'சதுரப் பிரமிடு',
  'fig.cylinder': 'உருளை',
  'fig.cone': 'கூம்பு',
  'fig.sphere': 'கோளம்',
  'fig.frustumPyramid': 'பிரமிடு துண்டு',
  'fig.frustumCone': 'கூம்பு துண்டு',
  'dim.length': 'நீளம்',
  'dim.width': 'அகலம்',
  'dim.height': 'உயரம்',
  'dim.side': 'பக்கம்',
  'dim.radius': 'ஆரம்',
  'dim.r1': 'கீழ் ஆரம்',
  'dim.r2': 'மேல் ஆரம்',
  'dim.sideBase': 'அடிப் பக்கம்',
  'dim.sideTop': 'மேல் பக்கம்',
  'info.face': 'முகம்',
  'info.center': 'மையம் வழியாக',
  'info.diagonal': 'மூலைவிட்டம்',
  'info.axial': 'அச்சு மூலைவிட்டம்',
  'info.diameter': 'விட்டம்',
  'info.generator': 'உருவாக்கி',
  'info.axis': 'அச்சு',
  'info.height': 'உயரம்',
  'info.median': 'நடுக்கோடு',
  'info.apothem': 'நடு உயரம்',
  'info.diameterBase': 'அடி விட்டம்',
  'info.diameterTop': 'மேல் விட்டம்',
};
